//
// Copyright (c) 2011-2024 by Curalate, Inc.
//
import React from 'react';
import { useSelector } from 'react-redux';

import { getIsGalleriesEnabled } from '@galleries/selectors/getIsGalleriesEnabled';
import { NavDropdownMenuItem } from '@legacy-components/nav3/navigation-menus/NavDropdownMenuItem';
import { NavMenuItem } from '@legacy-components/nav3/navigation-menus/NavMenuItem';
import { NAV_MENU_ITEMS_TRACKING_ID } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';
import { MediaMenu } from '@legacy-components/nav3/navigation-menus/dropdown-menus/MediaMenu';
import { getIsBazaarvoiceUgcSyndicationEnabled } from '@legacy-components/nav3/navigation-menus/selectors/getIsBazaarvoiceUgcSyndicationEnabled';
import { getIsSyndicationEnabled } from '@legacy-components/nav3/navigation-menus/selectors/getIsSyndicationEnabled';
import { getIsMediaLibraryPageEnabled } from '@media-library/redux/getMediaLibraryPage';
import {
  getIsShareV2Vendor,
  getIsSyndicationClient,
} from '@redux/selectors/getSessionInfo';
import { getIsBazaarvoiceNetworkSyndicationFrontendEnabled } from '@uia/rights/selectors/getUIARights';

import { NavGroup } from 'app/initialization/routing/stateHelpers';

export interface ContentNavProps {
  setIsMenuOpen: (isMenuOpen: boolean) => void;
}

export const ContentNav = ({ setIsMenuOpen }: ContentNavProps) => {
  const isBazaarvoiceSyndicationEnabled = useSelector(
    getIsBazaarvoiceNetworkSyndicationFrontendEnabled,
  );
  const isBazaarvoiceUgcSyndicationEnabled = useSelector(
    getIsBazaarvoiceUgcSyndicationEnabled,
  );
  const isGalleriesEnabled = useSelector(getIsGalleriesEnabled);
  const isMediaLibraryPageEnabled = useSelector(getIsMediaLibraryPageEnabled);
  const isSyndicationEnabled = useSelector(getIsSyndicationEnabled);
  const isSyndicationClient = useSelector(getIsSyndicationClient);
  const isShareEnabled = isSyndicationEnabled || isSyndicationClient;
  const isShareV2VendorClient = useSelector(getIsShareV2Vendor);
  const isBazaarvoiceSyndicationOnlyClient =
    (isSyndicationClient || isShareV2VendorClient) &&
    isBazaarvoiceSyndicationEnabled &&
    !isGalleriesEnabled &&
    !isBazaarvoiceUgcSyndicationEnabled;

  const isContentEnabled =
    !isBazaarvoiceSyndicationOnlyClient && isMediaLibraryPageEnabled;

  if (!isContentEnabled) {
    return null;
  }

  return isShareEnabled ? (
    <NavDropdownMenuItem
      activeNavGroup={[NavGroup.MEDIA]}
      content={<MediaMenu />}
      setIsMenuOpen={setIsMenuOpen}
      trackingId={NAV_MENU_ITEMS_TRACKING_ID.CONTENT_NAV}
    >
      Content
    </NavDropdownMenuItem>
  ) : (
    <NavMenuItem
      activeNavGroup={NavGroup.MEDIA}
      state='library.all-media'
      trackingId={NAV_MENU_ITEMS_TRACKING_ID.CONTENT_NAV}
    >
      Content
    </NavMenuItem>
  );
};
